function getAppointmentTableHeader(attendeeType) {
    var header = [];

    if(attendeeType == 'Exhibitor') {
        header =
        [
            {
                dataField: 'id',
                text: 'Actions',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '150px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'username',
                text: 'Name',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'userid',
                text: 'Email',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'begintime',
                text: 'Begin Time',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'endtime',
                text: 'End Time',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'meeting',
                text: 'Meeting URL',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            }
        ]
    }
    else {
        header =
        [
            {
                dataField: 'id',
                text: 'Actions',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '170px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'ownername',
                text: 'Name',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'ownerid',
                text: 'Email',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'begintime',
                text: 'Begin Time',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'endtime',
                text: 'End Time',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            },
            {
                dataField: 'meeting',
                text: 'Meeting URL',
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#00afeb', 
                  color: 'white',
                  width: '200px',
                  textAlign: 'center',
                }      
            }
        ]
    }

    return header;
}

module.exports = { getAppointmentTableHeader }